import ReactGA from "react-ga4";

export const initializeGA4 = (): void => {
  const measurementId = import.meta.env.VITE_GA4_MEASUREMENT_ID;

  if (!measurementId) {
    console.warn("GA4 Measurement ID not found");
    return;
  }

  const isProduction = import.meta.env.VITE_ENVIRONMENT === "production";

  ReactGA.initialize(measurementId, {
    gtagOptions: {
      send_page_view: true,
    },
  });

  if (!isProduction) {
    ReactGA.gtag("config", measurementId, {
      debug_mode: true,
    });
  }

  console.log(
    `GA4 initialized ${!isProduction ? "with DebugView" : "in production"}`,
  );
};

/**
 * Identify the signed-in user to GA4 once per page load: user_id for
 * cross-device dedupe, plus user-scoped properties for segmentation
 * (company, membership tier), and a `login` event (#9724).
 */
let identifiedUserId: number | null = null;

export const identifyUser = (settings: {
  userId: number;
  companyId: number;
  membershipType?: string | null;
  membershipTypeDetail?: string | null;
}): void => {
  if (identifiedUserId === settings.userId) return;
  identifiedUserId = settings.userId;

  ReactGA.set({ userId: String(settings.userId) });
  ReactGA.gtag("set", "user_properties", {
    company_id: String(settings.companyId),
    membership_type: settings.membershipType ?? "(none)",
    membership_detail: settings.membershipTypeDetail ?? "(none)",
  });
  ReactGA.event("login", { method: "auth0" });
};

export const trackEvent = (
  eventName: string,
  eventParams?: Record<string, unknown>,
): void => {
  ReactGA.event(eventName, eventParams);
};
